import { SVGProps } from "types/SVG";

export const WarningIcon = ({ alt, className }: SVGProps) => (
  <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <title>{alt}</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.25646 1.01971C6.03166 -0.339905 7.96867 -0.339905 8.74386 1.01971L13.3939 9.17983C14.1692 10.5397 13.2005 12.24 11.6502 12.24H2.35014C0.799866 12.24 -0.168811 10.5398 0.606365 9.17997L5.25646 1.01971ZM6.41885 1.69998L1.76891 9.85996C1.5106 10.313 1.8332 10.88 2.35014 10.88H11.6502C12.1671 10.88 12.4898 10.3132 12.2315 9.8601L7.58147 1.69998C7.32303 1.2467 6.6773 1.2467 6.41885 1.69998ZM7.00016 4.07989C7.37085 4.07989 7.67136 4.38434 7.67136 4.7599V6.78658C7.67136 7.16214 7.37085 7.46659 7.00016 7.46659C6.62947 7.46659 6.32897 7.16214 6.32897 6.78658V4.7599C6.32897 4.38434 6.62947 4.07989 7.00016 4.07989ZM6.32897 8.83995C6.32897 8.46439 6.62947 8.15994 7.00016 8.15994H7.00688C7.37756 8.15994 7.67807 8.46439 7.67807 8.83995C7.67807 9.21551 7.37756 9.51996 7.00688 9.51996H7.00016C6.62947 9.51996 6.32897 9.21551 6.32897 8.83995Z"
      fill="#FA9441"
    />
  </svg>
);
